module.exports = __webpack_public_path__ + "static/media/spain_id_card@2x.8e258c88.png";